import React, { useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
// import { getStoreActivityLogs } from "../../../redux/StoreManagement/storeManagementActions";
import EmptyState from "../../../components/EmptyState";
import { ContentCopy } from "@mui/icons-material";
import toast from "react-hot-toast";
import {
  LocalShipping,
  AssignmentTurnedIn,
  Cancel,
  TwoWheeler,
  Inventory,
} from "@mui/icons-material";
import ActivityLogDrawer from "./ActivityLogDrawer";

const StoreActivityLog = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  // const dispatch = useDispatch();
  const {
    // activityLogs,
    activityLogsLoading,
  } = useSelector((state) => state.storeManagement);

  // useEffect(() => {
  //   dispatch(getStoreActivityLogs({ page: 1, page_size: 5 }));
  // }, [dispatch]);

 
  const getActivityTypeBadgeStyle = (activityType) => {
    const styles = {
      STOCK_CONFIRMATION: "border-[#2B8C34] text-[#2B8C34] bg-white",
      STOCK_REQUEST: "border-[#D4A407] text-[#D4A407] bg-white",
      LOW_STOCK: "border-[#D4A407] text-[#D4A407] bg-white",
      STOCK_IN: "border-[#2B8C34] text-[#2B8C34] bg-white",
      STOCK_OUT: "border-[#B92020] text-[#B92020] bg-white",
      OUT_OF_STOCK: "border-[#B92020] text-[#B92020] bg-white",
      BACK_IN_STOCK: "border-[#2B8C34] text-[#2B8C34] bg-white",
      NEW_PRODUCT: "border-[#6B46C1] text-[#6B46C1] bg-white",
      STOCK_TRANSFER: "border-[#0066CC] text-[#0066CC] bg-white",
      "STOCK_TRANSFER-INCOMING": "border-[#0066CC] text-[#0066CC] bg-white",
      "STOCK_TRANSFER-OUTGOING": "border-[#0066CC] text-[#0066CC] bg-white",
      PURCHASE: "border-[#D4A407] text-[#D4A407] bg-white",
    };
    return styles[activityType] || "border-[#5F6D60] text-[#5F6D60] bg-[#F5F5F5]";
  };

    const getActivityTypeDisplay = (activityType) => {
    const displays = {
      STOCK_CONFIRMATION: "Stock Confirmation",
      STOCK_REQUEST: "Stock Request", 
      LOW_STOCK: "Low Stock Alert",
      STOCK_IN: "Stock Received",
      STOCK_OUT: "Stock Distributed",
      OUT_OF_STOCK: "Out of Stock",
      BACK_IN_STOCK: "Back in Stock",
      NEW_PRODUCT: "New Product Added",
      STOCK_TRANSFER: "Stock Transfer",
      "STOCK_TRANSFER-INCOMING": "Stock Transfer Incoming",
      "STOCK_TRANSFER-OUTGOING": "Stock Transfer Outgoing",
      PURCHASE: "Purchase Order",
    };
    return displays[activityType] || activityType;
  };

  const getStatusBadgeStyle = (status) => {
    const styles = {
      DISPATCHED: "border-[#0066CC] text-[#0066CC] bg-white",
      DELIVERED: "border-[#2B8C34] text-[#2B8C34] bg-white",
      PROCESSING: "border-[#D4A407] text-[#D4A407] bg-white",
      COMPLETED: "border-[#2B8C34] text-[#2B8C34] bg-white",
      CANCELLED: "border-[#B92020] text-[#B92020] bg-white",
      PENDING: "border-[#D4A407] text-[#D4A407] bg-white",
      CONFIRMED: "border-[#2B8C34] text-[#2B8C34] bg-white",
      REQUESTED: "border-[#D4A407] text-[#D4A407] bg-white",
    };
    return styles[status] || "border-[#5F6D60] text-[#5F6D60] bg-[#F5F5F5]";
  };

   const getStatusIcon = (status) => {
    const iconProps = { style: { fontSize: 14 } };
    switch (status?.toUpperCase()) {
      case "DISPATCHED":
        return <LocalShipping {...iconProps} />;
      case "DELIVERED":
      case "COMPLETED":
      case "CONFIRMED":
        return <AssignmentTurnedIn {...iconProps} />;
      case "CANCELLED":
        return <Cancel {...iconProps} />;
      case "PROCESSING":
      case "PENDING":
      case "REQUESTED":
        return <Inventory {...iconProps} />;
      default:
        return null;
    }
  };

   const handleCopyNumber = (number) => {
    navigator.clipboard.writeText(number);
    toast.success(`${number} copied successfully`);
  };

  const capitalizeFirstLetter = (str) => {
    return str?.charAt(0).toUpperCase() + str?.slice(1).toLowerCase() || "";
  };

  const handleShowMore = (e) => {
    e.preventDefault();
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  // Mock data for demonstration - will be replaced by real API data
  const mockActivityLogs = [
    {
      id: 1,
      activity_type: "STOCK_IN",
      activity_type_display: "Stock Received",
      timestamp: "2024-08-04T14:36:00Z",
      actor: { 
        name: "Grace Okoro", 
        username: "grace.okoro",
        role: "Store Manager" 
      },
      details: {
        quantity: 150,
        product_name: "Urea Fertilizer",
        variant_info: "50kg bags",
        location: "Kano Warehouse",
        status: "CONFIRMED"
      }
    },
    {
      id: 2,
      activity_type: "STOCK_TRANSFER-OUTGOING",
      activity_type_display: "Stock Transfer Outgoing",
      timestamp: "2024-08-04T12:15:00Z",
      actor: { 
        name: "John Adamu", 
        username: "john.adamu",
        role: "Inventory Manager" 
      },
      details: {
        quantity: 75,
        product_name: "Knapsack Sprayers",
        receiving_store: "Benin Store",
        status: "DISPATCHED"
      }
    },
    {
      id: 3,
      activity_type: "PURCHASE",
      activity_type_display: "Purchase Order",
      timestamp: "2024-08-04T10:22:00Z",
      actor: { 
        name: "Mary Johnson", 
        username: "mary.johnson",
        role: "Customer" 
      },
      details: {
        quantity: 25,
        product_name: "NPK Fertilizer",
        variant_info: "25kg bags",
        location: "Online Store",
        reference: "ORD-2024-001234",
        status: "PROCESSING"
      },
      deliveryType: "Express"
    },
   
  ];


  const displayLogs =  mockActivityLogs;

  return (
    <>
   <div className="bg-white border border-[#E1E6E1] rounded-lg">
      {/* Header */}
      <div className="flex justify-between items-center p-4 border-b border-[#E1E6E1]">
        <h6 className="text-[#2E332F] font-semibold text-sm">Activity Log</h6>
        <button 
          onClick={handleShowMore}
          className="text-[#2B8C34] text-sm font-semibold hover:underline cursor-pointer"
        >
          Show More
        </button>
      </div>

      {/* Activity Log Content */}
      <div className="max-h-96 overflow-y-auto">
        {activityLogsLoading ? (
          <div className="py-4 space-y-4">
            {[...Array(3)].map((_, index) => (
              <div key={index} className="animate-pulse">
                <div className="flex justify-between items-center mb-3 bg-gray-100 px-3 py-2 rounded">
                  <div className="h-6 bg-gray-200 rounded w-24"></div>
                  <div className="h-4 bg-gray-200 rounded w-32"></div>
                </div>
                <div className="space-y-2">
                  <div className="h-4 bg-gray-200 rounded w-full"></div>
                  <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                </div>
              </div>
            ))}
          </div>
        ) : displayLogs.length === 0 ? (
          <div className="p-8">
            <EmptyState text="No recent activity" />
          </div>
        ) : (
          displayLogs.map((activity, index) => (
            <div
              key={activity.id}
              className={`${
                index < displayLogs.length - 1
                  ? "border-b border-[#E1E6E1]"
                  : ""
              }`}
            >
              {/* Activity Type Badge and Timestamp */}
              <div className="flex justify-between items-center bg-[#F6F7F6] px-3 py-2 rounded">
                <span
                  className={`px-2 py-1 rounded border ${getActivityTypeBadgeStyle(
                    activity.activity_type
                  )} font-semibold text-xs`}
                >
                  {activity.activity_type_display || getActivityTypeDisplay(activity.activity_type)}
                </span>
                <span className="text-xs text-[#5F6D60] font-semibold">
                  {moment(activity.timestamp).format("h:mm A")}{" "}
                  <span className="text-[#A1A8A1] mr-2">|</span>
                  {moment(activity.timestamp).format("DD MMM YY")}
                </span>
              </div>

              {/* Activity Details */}
              <div className="space-y-0">
                {/* Unit Added/Transferred */}
                {activity.details?.quantity && (
                  <div className="flex items-center border-t border-[#E1E6E1] py-2 px-3 ">
                    <span className="text-xs font-semibold text-[#5F6D60] mr-2">
                      {activity.activity_type === "STOCK_IN"
                        ? "Unit Added:"
                        : activity.activity_type.includes("TRANSFER")
                        ? "Unit Transferred:"
                        : activity.activity_type === "PURCHASE"
                        ? "Unit Bought:"
                        : "Quantity:"}
                    </span>
                    <span
                      className={`text-xs font-semibold px-2 py-1 rounded border ${
                        activity.activity_type === "STOCK_IN" ||
                        activity.activity_type === "STOCK_TRANSFER-INCOMING"
                          ? "text-[#2B8C34] border-[#2B8C34] bg-[#EDF7EE]"
                          : "text-[#B92020] border-[#B92020] bg-[#FEE2E2]"
                      }`}
                    >
                      {activity.activity_type === "STOCK_IN" ||
                      activity.activity_type === "STOCK_TRANSFER-INCOMING"
                        ? "+"
                        : "-"}
                      {activity.details.quantity}
                    </span>
                  </div>
                )}

                {/* Product Information */}
                {activity.details?.product_name && (
                  <div className="flex items-center border-t border-[#E1E6E1] py-2 px-3">
                    <span className="text-xs text-[#5F6D60] font-semibold mr-2">Product:</span>
                    <div className="border border-[#E1E6E1] rounded py-1 px-2 w-fit text-[#5F6D60] font-semibold text-xs bg-white">
                      {activity.details.product_name}
                      {activity.details.variant_info && ` / ${activity.details.variant_info}`}
                    </div>
                  </div>
                )}

                {/* Actor Information */}
                {activity.actor && activity.actor.name !== "System" && (
                  <div className="flex items-center border-t border-[#E1E6E1] py-2 px-3">
                    <span className="text-xs font-semibold text-[#5F6D60] mr-2">
                      {activity.activity_type === "STOCK_IN"
                        ? "Stock Added By:"
                        : activity.activity_type.includes("TRANSFER")
                        ? "Stock Transferred By:"
                        : activity.activity_type === "PURCHASE"
                        ? "Ordered By:"
                        : "Performed By:"}
                    </span>
                    <span className="text-xs font-semibold text-[#2E332F]">
                      {activity.actor.name || activity.actor.username}
                    </span>
                    {activity.actor.role && (
                      <span className="text-xs text-[#5F6D60] ml-2 bg-[#F6F7F6] font-semibold border border-[#E1E6E1] px-2 py-1 rounded">
                        {activity.actor.role}
                      </span>
                    )}
                  </div>
                )}

                {/* Source Store for TRANSFER-INCOMING */}
                {activity.activity_type === "STOCK_TRANSFER-INCOMING" &&
                  activity.details?.source_store && (
                    <div className="flex items-center border-t border-[#E1E6E1] py-2 px-3">
                      <span className="text-xs font-semibold text-[#5F6D60] mr-2">
                        Source Store:
                      </span>
                      <span className="text-xs text-[#5F6D60] font-semibold bg-[#F6F7F6] border border-[#E1E6E1] px-2 py-1 rounded">
                        {activity.details.source_store}
                      </span>
                    </div>
                  )}

                {/* Receiving Store for TRANSFER-OUTGOING */}
                {activity.activity_type === "STOCK_TRANSFER-OUTGOING" &&
                  activity.details?.receiving_store && (
                    <div className="flex items-center border-t border-[#E1E6E1] py-2 px-3">
                      <span className="text-xs font-semibold text-[#5F6D60] mr-2">
                        Receiving Store:
                      </span>
                      <span className="text-xs text-[#5F6D60] font-semibold bg-[#F6F7F6] border border-[#E1E6E1] px-2 py-1 rounded">
                        {activity.details.receiving_store}
                      </span>
                    </div>
                  )}

                {/* Location/Store Information for other activity types */}
                {!activity.activity_type.includes("TRANSFER") &&
                  activity.details?.location && (
                    <div className="items-center border-t border-[#E1E6E1] flex justify-between pr-2 py-2 px-3">
                      <div className="flex items-center">
                        <span className="text-xs font-semibold text-[#5F6D60] mr-2">
                          {activity.activity_type === "PURCHASE"
                            ? "Channel:"
                            : "Location:"}
                        </span>

                        <span
                          className={`text-xs font-semibold ${
                            activity.activity_type === "PURCHASE"
                              ? "text-[#5F6D60] bg-[#F6F7F6] border border-[#E1E6E1] px-2 py-1 rounded"
                              : "text-[#2E332F]"
                          }`}
                        >
                          {activity.details.location}
                        </span>
                      </div>

                      {activity.activity_type === "PURCHASE" && activity.deliveryType && (
                        <span className="text-xs text-[#5F6D60] font-semibold bg-[#F6F7F6] border border-[#E1E6E1] px-2 py-1 rounded flex items-center gap-1 ml-2">
                          <TwoWheeler
                            className="text-[#5F6D60] cursor-pointer"
                            style={{ fontSize: "12px" }}
                          />
                          {activity.deliveryType}
                        </span>
                      )}
                    </div>
                  )}

                {/* Order ID for purchases */}
                {activity.details?.reference &&
                  activity.activity_type === "PURCHASE" && (
                    <div className="flex items-center border-t border-[#E1E6E1] py-2 px-3">
                      <span className="text-xs font-semibold text-[#5F6D60] mr-2">
                        Order ID:
                      </span>
                      <div className="border border-[#E1E6E1] px-1 py-1 rounded bg-white w-fit gap-0.5 flex items-center text-xs text-[#5F6D60] font-semibold">
                        {activity.details.reference}
                        <ContentCopy
                          className="text-[#5F6D60] cursor-pointer"
                          style={{ fontSize: "10px" }}
                          onClick={() =>
                            handleCopyNumber(activity.details.reference)
                          }
                        />
                      </div>
                    </div>
                  )}

                {/* Status with Icon */}
                {activity.details?.status && (
                  <div className="flex items-center border-t border-[#E1E6E1] py-2 px-3">
                    <span className="text-xs font-semibold text-[#5F6D60] mr-2">Status:</span>
                    <div className="flex items-center">
                      <span
                        className={`px-2 py-1 rounded border ${getStatusBadgeStyle(
                          activity.details.status
                        )} font-semibold text-xs flex items-center gap-1`}
                      >
                        {getStatusIcon(activity.details.status)}
                        {capitalizeFirstLetter(activity.details.status)}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>

      {/* Activity Log Drawer */}
      <ActivityLogDrawer 
        isOpen={isDrawerOpen}
        onClose={handleCloseDrawer}
      />
    </>
  );
};

export default StoreActivityLog;